export * from './HOCs';
export { default as reducer } from './search.ducks';



// WEBPACK FOOTER //
// ./src/routes/Search/index.ts